import { render, staticRenderFns } from "./OrderRequestTransferModal.vue?vue&type=template&id=5713d0bd&"
import script from "./OrderRequestTransferModal.vue?vue&type=script&lang=js&"
export * from "./OrderRequestTransferModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderRequestTransferModal.vue?vue&type=style&index=0&id=5713d0bd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports